import * as types from '../../constants/backoffice/partnerConstants';

export const partnerAccountListRequest = (page, pageLength, searchString) => ({
  type: types.PARTNER_ACCOUNT_LIST_REQUEST,
  page,
  pageLength,
  searchString
});

export const setPartnerAccountList = (list) => ({
  type: types.SET_PARTNER_ACCOUNT_LIST,
  list
});

export const setTotalCount = totalCount => ({
  type: types.SET_TOTAL_COUNT,
  totalCount
});

export const setPartnerPagination = (page, totalCount, searchString) => ({
  type: types.SET_PARTNER_PAGINATION,
  page,
  totalCount,
  searchString
});

export const partnerEmailCheck = (email) => ({
  type: types.PARTNER_EMAIL_CHECK,
  email,
});

export const setResponse = (data) => ({
  type: types.PARTNER_EMAIL_CHECK,
  data
});

export const createPartner = (email) => ({
  type: types.CREATE_PARTNER,
  email
});

export const removePartner = (accountNo) => ({
  type: types.REMOVE_PARTNER,
  accountNo
});

export const partnerDetails = (accountNo) => ({
  type: types.PARTNER_ACCOUNT_DETAIL,
  accountNo
});

export const setPartnerDetails = (appList) => ({
  type: types.PARTNER_ACCOUNT_DETAIL,
  appList
});
